module.exports = __webpack_public_path__ + "img/dotted-h-line-3.694d983f.svg";